import Emitter from "component-emitter";
import { debounce } from "lodash";

class CollectionManagement {
    constructor() {
        this.containers = document.querySelectorAll(
            "[data-collection-management]"
        );
        this.init();
        this.userAuthenticated = false;
    }

    setUserAuthenticated() {
        this.userAuthenticated = true;
        // Re-enable all checkboxes when user becomes authenticated
        this.containers.forEach((container) => {
            const checkboxes = container.querySelectorAll(
                "input[type='checkbox']"
            );
            checkboxes.forEach((checkbox) => {
                checkbox.disabled = false;
            });
            // Hide login message
            const loginMessage =
                container.parentNode.querySelector(".login-message");
            if (loginMessage) {
                loginMessage.classList.add("hidden");
            }
        });
    }

    async init() {
        for (const container of this.containers) {
            const collectionKey = container.dataset.collectionManagement;
            const checkboxes = container.querySelectorAll(
                "input[type='checkbox']"
            );

            if (!this.userAuthenticated) {
                // Disable all checkboxes
                checkboxes.forEach((checkbox) => {
                    checkbox.disabled = true;
                });

                // Show login message
                const loginMessage =
                    container.parentNode.querySelector(".login-message");
                if (loginMessage) {
                    loginMessage.classList.remove("hidden");
                }
            }

            // Hide login message if it exists
            const loginMessage =
                container.parentNode.querySelector(".login-message");
            if (loginMessage) {
                loginMessage.classList.add("hidden");
            }

            // Fetch initial collection state
            try {
                const response = await fetch(
                    "/account/collection/" + collectionKey + "/"
                );
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                const data = await response.json();

                // Check boxes that are in the collection
                checkboxes.forEach((checkbox) => {
                    if (data.collection.includes(checkbox.value)) {
                        checkbox.checked = true;
                    }
                });
            } catch (error) {
                console.error("Error loading collection state:", error);
            }

            // Add change listeners
            checkboxes.forEach((checkbox) => {
                checkbox.addEventListener("change", () => {
                    if (this.userAuthenticated) {
                        this.debouncedUpdateCollection(container);
                    }
                });
            });
        }
    }

    debouncedUpdateCollection = debounce(async (container) => {
        const collectionKey = container.dataset.collectionManagement;
        const checkedIds = Array.from(
            container.querySelectorAll("input[type='checkbox']:checked")
        ).map((checkbox) => checkbox.value);

        try {
            const response = await fetch(
                "/account/collection/" + collectionKey + "/",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                    },
                    body: new URLSearchParams({
                        ids: checkedIds.join(","),
                    }),
                }
            );

            if (!response.ok) {
                throw new Error("Network response was not ok");
            }

            const data = await response.json();
            this.emit("collectionUpdated", data.collection);
        } catch (error) {
            console.error("Error updating collection:", error);
            // Revert all checkboxes to their previous state
            const response = await fetch(
                "/account/collection/" + collectionKey + "/"
            );
            if (response.ok) {
                const data = await response.json();
                const checkboxes = container.querySelectorAll(
                    "input[type='checkbox']"
                );
                checkboxes.forEach((checkbox) => {
                    checkbox.checked = data.collection.includes(checkbox.value);
                });
            }
        }
    }, 1000);
}

Emitter(CollectionManagement.prototype);

export default CollectionManagement;
